import React, { FunctionComponent } from 'react';
import { AlertBox, SpacingName } from '@doveit/bricks';
import { LATEST_REVIEWS } from '../../graphql/queries/reviews';
import CardsHList from '../../components/cards-hlist/CardsHList';
import ReviewCard, { ReviewCardSkeleton } from '../../components/review-card/ReviewCard';
import { ReviewTarget } from '../../../domain/graphcms';
import useQuery from '../../hooks/useQuery/useQuery';

const ERROR_MESSAGE = 'Errore durante il caricamento delle recensioni.';

export interface ListReviewsProps {
  target?: ReviewTarget[],
  count?: number,
  minRating?: 1 | 2 | 3 | 4 | 5,
}

const ListReviews: FunctionComponent<ListReviewsProps> = ({
  target,
  count,
  minRating,
}) => {
  const { error, data } = useQuery({ query: LATEST_REVIEWS, variables: { count, target, minRating } });

  if (error) {
    return (
      <AlertBox
        message={ERROR_MESSAGE}
      />
    );
  }

  if (!data) {
    return (
      <CardsHList sideSpacing={SpacingName.SMALL}>
        {[1, 2, 3].map((i) => (
          <CardsHList.Item
            key={`review-skeleton-card-${i}`}
          >
            <ReviewCardSkeleton />
          </CardsHList.Item>
        ))}
      </CardsHList>
    );
  }

  return (
    <CardsHList
      sideSpacing={SpacingName.SMALL}
      inline={3}
    >
      {data.reviews.map((review) => (
        <CardsHList.Item
          key={review.id}
        >
          <ReviewCard {...review} />
        </CardsHList.Item>
      ))}
    </CardsHList>
  );
};

export default ListReviews;
